import { ComponentProps } from 'react';
import { Col } from 'antd';
import clsx from 'clsx';

interface IOpColProps extends ComponentProps<typeof Col> {
  testId?: string;
}

export const OpCol = ({
  className,
  testId = 'op-col',
  ...colProps
}: IOpColProps) => {
  return (
    <Col
      className={clsx('op-col', className)}
      data-testid={testId}
      {...colProps}
    />
  );
};
